import React from 'react';
import { getRoleInfo, getRoleColor } from '../../constants/programRoles';

export default function RoleBadge({ role }) {
  const roleInfo = getRoleInfo(role);
  const displayName = roleInfo.display;
  const category = roleInfo.category;
  const color = getRoleColor(role);
  
  return (
    <span 
      style={{
        display: 'inline-block',
        padding: '3px 8px',
        borderRadius: '12px',
        background: color,
        color: 'white',
        fontSize: 11,
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
      title={`${displayName} (${category || 'Unknown'} Role)`}
    >
      {displayName}
    </span>
  );
}



